import { Collapse } from '@/shared/common/collapse/collapse';

const historyCollapse = document.querySelector('.js-history-collapse');

export const mainHistoryCollapse = () => {
	historyCollapse &&
		new Collapse(historyCollapse, {
			selectorElement: '.js-history-collapse > .collapse__element',
			selectorButton: '.collapse__button',
			selectorContent: '.collapse__content',
		});
};
